module.exports = __webpack_public_path__ + "b541bc4b205edda1d494d5d77f34fba2.jpg";